import { getListingAllocatedDebt } from 'app/services/agentApi';
import { useMemo, useState } from 'react';
import { useDebounce } from 'utils/hooks/useDebounce';
import useFetchData from './useFetchData';

interface useAllocatedDebtProps {
  search?: string;
  onBefore?: () => void;
  onSuccess?: (response) => void;
  onError?: () => void;
  IIFE?: boolean;
}

const useAllocatedDebt = (params?: useAllocatedDebtProps) => {
  const { search = '', onBefore, onError, onSuccess, IIFE } = params ?? {};
  const [isSearching, setIsSearching] = useState(true);
  const debouncedSearchValue = useDebounce({ value: search, delay: 500 });

  const getListingAllocatedDebtPayload = useMemo(
    () => ({
      name: debouncedSearchValue,
    }),
    [debouncedSearchValue],
  );

  const { result } = useFetchData({
    actionApi: getListingAllocatedDebt,
    payloadData: getListingAllocatedDebtPayload,
    IIFE,
    onBefore: () => {
      onBefore?.();
      setIsSearching(true);
    },
    onSuccess: response => {
      onSuccess?.(response);
      setIsSearching(false);
    },
    onError: () => {
      onError?.();
      setIsSearching(false);
    },
  });

  return {
    isSearching,
    result,
  };
};

export default useAllocatedDebt;
